/* istanbul ignore file */
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

//All components imports
import { AppComponent } from './app.component';
import { CallbackComponent } from './components/callback/callback.component';
import { NotificationHomeComponent } from './components/notification-home/notification-home.component';
import { HeaderComponent } from './components/header/header.component';
import { ScheduleEventDialogComponent } from './components/schedule-event-dialog/schedule-event-dialog.component';
import { NotificationPreferenceComponent } from './components/notification-preference/notification-preference.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { NoticesDialogComponent } from './components/header/notices-dialog/notices-dialog.component';

//All modules imports
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

//All services imports
import { AuthService } from './services/auth.service';
import { interceptorProviders } from './services/interceptor';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { SnackBarService } from './services/snackbar.service';

//Pipe Import
import { HighlightSearchPipe } from './pipes/highlightSearchPipe';

//All material modules imports
import { material } from './material';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatDialogRef, MatDialogState} from '@angular/material/dialog';
import { LogoutDialogComponent } from './components/logout-dialog/logout-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    CallbackComponent,
    NotificationHomeComponent,
    HeaderComponent,
    ScheduleEventDialogComponent,
    NotificationPreferenceComponent,
    ConfirmationPopupComponent,
    HighlightSearchPipe,
    SnackbarComponent,
    NoticesDialogComponent,
    LogoutDialogComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    MatDialogModule,
    material,
  ],
  providers: [
    AuthService,
    interceptorProviders,
    CanDeactivateGuard,
    SnackBarService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
